import { motion } from "framer-motion";
import { CalendarCheck, MailOpen, MessagesSquare } from "lucide-react";

const STEPS = [
    {
        icon: MailOpen,
        title: "Send an enquiry",
        text: "Tell us your child’s grade and the English skills you would like to focus on.",
    },
    {
        icon: MessagesSquare,
        title: "Have a consultation",
        text: "Discuss your goals, questions, lesson format and whether our approach is a good fit.",
    },
    {
        icon: CalendarCheck,
        title: "Plan the learning",
        text: "If you decide to proceed, agree on a schedule and a learning focus for your child.",
    },
];

export const Steps = () => (
    <section className="mx-auto max-w-7xl px-6 py-20 lg:py-28" data-testid="steps-section">
        <motion.div
            className="max-w-2xl"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
        >
            <p className="text-xs font-bold tracking-widest text-sun uppercase">Getting started</p>
            <h2 className="font-heading mt-3 text-3xl font-extrabold tracking-tight text-ink sm:text-4xl">
                Three simple steps
            </h2>
            <p className="mt-4 text-base text-mist sm:text-lg">
                Start with a conversation so we can understand what your child needs.
            </p>
        </motion.div>
        <div className="mt-12 grid gap-6 md:grid-cols-3">
            {STEPS.map((step, i) => (
                <motion.div
                    key={step.title}
                    data-testid={`getting-started-step-${i + 1}`}
                    className="flex items-start gap-5 rounded-3xl border border-ground-line/70 bg-ground-soft/50 p-7 transition-all duration-300 hover:-translate-y-1 hover:border-sun/50"
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.55, delay: i * 0.12 }}
                >
                    <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-sun/15 text-sun">
                        <step.icon className="h-6 w-6" />
                    </span>
                    <div>
                        <h3 className="font-heading text-lg font-bold text-ink">{step.title}</h3>
                        <p className="mt-2 text-sm leading-relaxed text-mist">{step.text}</p>
                    </div>
                </motion.div>
            ))}
        </div>
    </section>
);
